import React from "react";
import { imageUrlOthers } from "../../services/CommonUrl";

const MultipleImage = ({ imageList, setImageList }) => {
  const isPDF = (file) => typeof file === "string" && /\.pdf$/i.test(file);
  const selectAvatarImg = async (event) => {
    if (Array.from(event.target.files).length > 0) {
      let imgArr = [];

      Array.from(event.target.files).map((item) => {
        // console.log("======item=====>", item);
        imgArr.push(item);
      });

      setImageList([...imageList, ...imgArr]);
    }
  };

  const deleteImage = (index) => {
    let tempArr = imageList;
    tempArr.splice(index, 1);
    setImageList([...tempArr]);
  };

  return (
    <div className="ci-images-block">
      <label className="ci-upload-block">
        <span className="ci-upload-icon">
          <i className="bi bi-cloud-upload"></i>
          <span className="ci-upload-content">
            <b>Upload Photos</b>
            <small className="d-block">File size must be under 5 Mb</small>
          </span>
        </span>
        <input
          onChange={selectAvatarImg}
          onClick={(event) => {
            event.target.value = null;
          }}
          accept="image/x-png,image/gif,image/jpeg,application/pdf"
          type="file"
          name="file"
          multiple={true}
        />
      </label>

      <div className="ci-other-img-field d-flex flex-wrap">
        {imageList.length > 0 &&
          imageList.map((item, index) => {
            return (
              <div key={index} className="ci-other-img-item">
                <>
                  {item?.type == "application/pdf" || isPDF(item) ? (
                    <div className="ci-other-img-block ci-pdf-block">
                      <i className="bi bi-file-pdf"></i>
                    </div>
                  ) : (
                    <div className="ci-other-img-block">
                      <img
                        src={
                          typeof item == "string"
                            ? imageUrlOthers + item
                            : URL.createObjectURL(item)
                        }
                        alt=""
                      />
                    </div>
                  )}
                </>
                <i
                  className="bi bi-trash3"
                  onClick={() => deleteImage(index)}
                ></i>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MultipleImage;
